// Init Firestore
import _ from 'lodash';
import moment from 'moment';
import axios from 'axios';
import { auth, db, fieldValue } from '../services/firebase';

// For zipping and downloading media files
import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';

const Respondents = db.collection('respondents');
const Surveys = db.collection('studies');
const Users = db.collection('users');
const Accounts = db.collection('accounts');
const Misc = db.collection('misc');

var db_helper = {

  addGoogleDataToUserDoc: function(uid, user, invite_id=null) {

    return new Promise((resolve, reject) => {

      try {

        // See if the user already has an account
        Users.doc(uid).get().then(async doc => {

          // If user doesn't exist (tried to login without an account), add them to Firebase
          if (!doc.exists) {

            // TODO: Check to see if the user has already been invted to join an account.
            let user_data = {
              uid,
              time_created: moment().unix(),
              email: user.email || '',
              phone: user.phoneNumber || '',
              profile_pic: user.photoURL || '',
              name: user.displayName || ''
            };

            // if (analytics) {
            //   //analytics.identify(uid, { X });
            // } else {
            //   console.log('Analytics not available in db_helper');
            // };

            if (user.displayName) {
              let names = user.displayName.split(' ');
              user_data.first_name = names[0];
              if (names.length > 1) {
                user_data.last_name = names[names.length - 1];
              };
            };

            // Add the user's data to Firestore under their newly generated uid
            Users.doc(uid).set(user_data).then(async () => {

              // Link account server-side
              try {
                await axios.put(`https://api-outsidevoice.vercel.app/init-user-account`, { uid, invite_id });
                resolve();
                return;
              } catch (err) {
                reject(err);
                return;
              };

            }).catch(err => {
              reject(err);
              return;
            });


          // The user already exists in the database, If they had previously signed up with email, see if I can supplement their data with data from Google
          } else {

            let existing_user_data = doc.data();

            // Add the profile_pic and phone number from Google if the user doesn't have either set yet.
            if ((!existing_user_data.name ||!existing_user_data.profile_pic || !existing_user_data.phone || !existing_user_data.email) && (user.displayName ||user.phoneNumber || user.photoURL || user.email)) {

              let new_data = {};
              if (user.displayName) {
                new_data.name = user.displayName;
                let names = user.displayName.split(' ');
                new_data.first_name = names[0];
                if (names.length > 1) {
                  new_data.last_name = names[names.length - 1];
                };
              };

              if (user.email) {
                new_data.email = user.email;
              };
              if (user.phoneNumber) {
                new_data.phone = user.phoneNumber;
              };
              if (user.photoURL) {
                new_data.profile_pic = user.photoURL;
              };

              // Add the user's data to Firestore under their newly generated uid
              Users.doc(uid).update(new_data).then(() => {
                resolve();
                return;
              }).catch(err => {
                reject(err);
                return;
              });

            // Simply an existing user, just log them in.
            } else {
              resolve();
              return;
            };

          };

        // Error getting user from Firebase
        }).catch(err => {
          reject(err);
        });
      } catch (err) {
        reject(err);
      };

    });

  },

  getFormattedSurveyJSON: function(survey) {
    return new Promise(async (resolve, reject) => {
      let survey_answers = await getFormattedSurveyAnswers(survey);
      resolve(survey_answers);
    });
  },



  getFormattedSurveyCSV: function(survey) {

    return new Promise(async (resolve, reject) => {

      // Get an array of answer objects
      let [answers_arr, uids_to_push_phone_numbers] = await Promise.all([
        getFormattedSurveyAnswers(survey), // Returns an array of all the answers with necessary info
        getUIDsForPushPhoneNumbers(survey.id)
      ]);

      let answers_by_respondent = [];
      let is_external_uid = false;
      let is_phone_numbers = false;

      for (let answer of answers_arr) {

        let respondent_answer_index = _.findIndex(answers_by_respondent, ['uid', answer.uid]);

        // Initialize row entry
        if (respondent_answer_index === -1) {

          let respondent_entry = {
            uid: answer.uid,
            platform: (answer.platform || 'whatsapp'),
          };

          respondent_entry[`${answer.question_index + 1}. time_answered`] = moment.unix(answer.time_created).format("MMM Do h:mm a");

          // Add the external id to the user if there was one passed in.
          if (answer.external_uid) {
            is_external_uid = true;
            respondent_entry.external_uid = answer.external_uid;
          };

          // Add phone number if the client explicity sent the survey to phone number via push
          if (uids_to_push_phone_numbers && uids_to_push_phone_numbers[answer.uid]) {
            is_phone_numbers = true;
            respondent_entry.phone_number = uids_to_push_phone_numbers[answer.uid];
          };

          respondent_entry[`${answer.question_index + 1}. ${answer.question_text}`] = answer.answer;

          // Add answer transcript if there is one.
          if (answer.transcription) {
            respondent_entry[`${answer.question_index + 1}. transcription`] = answer.transcription;
          };

          if (answer.labels) {
            respondent_entry[`${answer.question_index + 1}. brands detected`] = answer.labels.join(',');
          };

          answers_by_respondent.push(respondent_entry);


        // Row already inited, add additional answer
        } else {

          answers_by_respondent[respondent_answer_index][`${answer.question_index + 1}. ${answer.question_text}`] = answer.answer;

          answers_by_respondent[respondent_answer_index][`${answer.question_index + 1}. time_answered`] = moment.unix(answer.time_created).format("MMM Do h:mm a");

          if (answer.transcription) {
            answers_by_respondent[respondent_answer_index][`${answer.question_index + 1}. transcription`] = answer.transcription;
          };

          if (answer.labels) {
            answers_by_respondent[respondent_answer_index][`${answer.question_index + 1}. brands detected`] = answer.labels.join(',');
          };

        };
      };

      let question_keys = ['uid'];

      let question_indexes = _.chain(answers_arr).map(answer => parseInt(answer.question_index)).uniq().value();

      question_indexes.sort((a, b) => a - b);

      for (let index of question_indexes) {

        let question_text = survey.questions[index] ? survey.questions[index].text : '';
        question_keys.push(`${index + 1}. ${question_text}`);

        if (survey.questions[index].answer_type === 'audio' || survey.questions[index].answer_type === 'video') {
          question_keys.push(`${index + 1}. transcription`);
        };

        if (survey.questions[index].answer_type === 'image' && survey.questions[index].answer_options && survey.questions[index].answer_options.is_image_intelligence) {
          question_keys.push(`${index + 1}. transcription`);
          question_keys.push(`${index + 1}. brands detected`);
        };

        question_keys.push(`${index + 1}. time_answered`);

      };

      question_keys.push('platform');

      if (is_phone_numbers) {
        question_keys.push('phone_number');
      };

      if (is_external_uid) {
        question_keys.push('external_uid');
      };

      answers_by_respondent = _.orderBy(answers_by_respondent, ['uid'], ['asc']); // Order answers by uid

      resolve([answers_by_respondent, question_keys]);


    });
  },


  exportMedia: function(survey) {

    return new Promise(async (resolve, reject) => {

      var zip = new JSZip();

      let survey_answers = await getFormattedSurveyAnswers(survey);
      let media_answers = _.filter(survey_answers, ans => ans.answer && String(ans.answer).includes('storage.googleapis.com'));

      if (!media_answers || media_answers.length === 0) {
        resolve(false);
        return;
      };

      for (let chunk of _.chunk(media_answers, 15)) { // Zip remote urls 15 at a time
        await Promise.all(_.map(chunk, ans => new Promise(async (resolve, reject) => {
          try {
            let media_urls = [ans.answer];
            if (ans.answer.includes(', ')) { // Split multi-part answers into separate urls
              media_urls = ans.answer.split(', ');
            };
            for (var i = 0; i < media_urls.length; i++) {
              let media_url = media_urls[i];
              let file = await JSZipUtils.getBinaryContent(media_url);
              let question_index = parseInt(ans.question_index) + 1;
              let uid = ans.uid;
              let file_type = media_url.slice(media_url.length - 3);
              if (media_url.includes('jpeg')) {
                file_type = 'jpeg';
              };
              if (media_url.includes('fbcdn.net')) {
                file_type = 'jpg';
              };
              var filename = `Q${question_index}-${uid}.${file_type}`;
              if (i > 0) {
                filename = `Q${question_index}-${uid}-${i}.${file_type}`;
              };
              zip.file(filename, file, { binary: true });
            };
          } catch (err) {
            console.log('error zipping file', err);
          };
          resolve();
        })))
      };

      zip.generateAsync({type:'blob'}).then(function(content) {
        resolve(content);
      });

    });
  },

  getRandomID: function() {
    const length = 8;
    const possible = "abcdefghijklmnopqrstuvwxyz0123456789";
    var text = "";
    for (var i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    };
    return text;
  },

  getRandomAPIKey: function() {
    const length = 35;
    const possible = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    var text = "";
    for (var i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    };
    return text;
  },


  getInvite: function(invite_id) {
    return new Promise(async (resolve, reject) => {
      try {
        Misc.doc('teammate_invites').collection('invites').doc(invite_id).get().then(doc => {
          if (doc.exists) {
            resolve(doc.data());
          } else {
            resolve(null);
          };
        });
      } catch (err) {
        console.log('Err getting invite', err);
        resolve(null);
      };
    });
  },


  getUser: function(user_id) {
    return new Promise(async (resolve, reject) => {
      try {
        Users.doc(user_id).get().then(doc => {
          if (doc.exists) {
            resolve(doc.data());
          } else {
            resolve(null);
          };
        });
      } catch (err) {
        console.log('Err getting user', err);
        resolve(null);
      };
    });
  },

};



function getFormattedSurveyAnswers(survey) {

  return new Promise((resolve, reject) => {

    Surveys.doc(survey.id).collection('answers').orderBy('time_created', 'desc').get().then(async snapshot => {

      if (snapshot.empty) {
        resolve([]);
      } else {

        let answers = [];
        let uids = [];

        snapshot.forEach(doc => {

          let data = doc.data();
          uids.push(data.uid);

          // Init answer object
          let answer = {
            uid: data.uid,
            answer_id: doc.id,
            question_type: data.answer_type,
            question_text: (survey.questions[data.question_index] ? survey.questions[data.question_index].text : ''),
            question_index: data.question_index,
            //time_created: moment.unix(data.time_created).format("MMM Do h:mm a"),
            time_created: data.time_created,
            answer: data.answer
          };

          // Get multi-choice answer text
          if (data.answer_type === 'multi_choice' && data.answer !== undefined) {
            if (survey.questions[data.question_index].multi_choice[data.answer]) {
              answer.answer = survey.questions[data.question_index].multi_choice[data.answer].text || survey.questions[data.question_index].multi_choice[data.answer];
            };
          };

          // Add transcription if there is one
          if (data.answer_type === 'audio' || data.answer_type === 'video') {
            answer.transcription = data.transcription || '';
          };

          // Add transcription and labels if there are any
          if (data.answer_type === 'image') {
            if (data.transcription) {
              answer.transcription = data.transcription;
            };
            if (data.labels) {
              answer.labels = data.labels;
            };
          };

          answers.push(answer);

        });

        // Get all the unique UIDs
        uids = _.uniq(uids);

        // Get info for all the Respondents
        let all_respondents = await Promise.all(_.map(uids, uid => {
          return new Promise(async (resolve, reject) => {
            let respondent = await getRespondent(uid);
            resolve(respondent);
          });
        }));


        // Enrich answers with relevant respondent info
        answers = _.map(answers, answer => {

          let uid = answer.uid;

          let respondent = _.find(all_respondents, ['uid', uid]);
          if (respondent) {
            if (respondent.platform) {
              answer.platform = respondent.platform;
            };
            if (respondent.uid_panel) {
              answer.external_uid = respondent.uid_panel;
            };
          };
          return answer;
        });


        // LOGIC TO GROUP ANSWERS PROPERLY (multi-select, multi-part and multiple run-throughs)

        // Find the index of the first indexable question (not Say and not multipart or multiselect)
        let first_question_index = _.findIndex(_.values(survey.questions), function(question) {
          let is_multiselect_or_is_multipart = question.answer_options && (question.answer_options.is_multiselect || question.answer_options.is_multipart);
          return question.answer_type !== 'say' && !is_multiselect_or_is_multipart;
        }) || 0;


        // Index each uid appropriately to designate separate survey run-throughs
        for (let uid of uids) {

          // Create an array of the run-through timestamps for the respondent to group answers
          let run_through_time_indexes = _.chain(answers).filter({ 'question_index': first_question_index, 'uid': uid }).map('time_created').value().sort();

          // // Change UID's of respondents answers to designate various run-throughs
          for (let i = 0; i < answers.length; i++) {

            if (answers[i].uid === uid) {

              // Find out in what index of the first question run throughs the answer would go.
              let run_throughs = _.clone(run_through_time_indexes);
              run_throughs.push(answers[i].time_created + 1);
              run_throughs.sort();
              let run_through_index = run_throughs.indexOf(answers[i].time_created + 1) - 1;

              //Index UID appropriately
              if (run_through_index >= 1) {
                answers[i].uid = `${uid}-${run_through_index}`;
              };
            };

          };

        };


        // Get new list of indexed UIDs
        let indexed_uids = _.chain(answers).map('uid').uniq().value();


        // Combine multi-part answers and remove unnecessary ones
        for (let uid of indexed_uids) {

          _.forEach(survey.questions, (question, question_index) => {

            let is_multiselect_or_is_multipart = question.answer_options && (question.answer_options.is_multiselect || question.answer_options.is_multipart);

            if (is_multiselect_or_is_multipart) {

              let answer_batch = _.filter(answers, { 'question_index': parseInt(question_index), 'uid': uid });

              let concatenated_answer = _.map(answer_batch, 'answer').join('; ');

              for (let i = 0; i < answer_batch.length; i++) {
                let matching_index = _.findIndex(answers, { 'answer_id': answer_batch[i].answer_id });
                if (matching_index !== -1) {
                  answers[matching_index].answer = concatenated_answer;
                  if (i === 0) {
                    answers[matching_index].answer = concatenated_answer;
                  } else {
                    answers.splice(matching_index+i, 1);
                  };
                };
              };

            };

          });
        };

        resolve(answers);

      };
    });

  });
};



function getUIDsForPushPhoneNumbers(survey_id) {
  return new Promise(async (resolve, reject) => {
    Surveys.doc(survey_id).collection('whatsapp_pushes').get().then(function(snapshot) {
      let uids_to_push_phone_numbers = {};
      snapshot.forEach(function(doc) {
        let data = doc.data();
        if (data.respondent_id && data.phone) {
          uids_to_push_phone_numbers[data.respondent_id] = data.phone;
        };
      });
      resolve(uids_to_push_phone_numbers);
    }).catch(err => {
      console.log('Error getting survey whatsapp pushes', err);
      resolve([]);
    });
  });
};


function getRespondent(uid) {
  return new Promise(async (resolve, reject) => {
    try {
      Respondents.doc(uid).get().then(doc => {
        if (doc.exists) {
          let respondent_data = doc.data();
          respondent_data.uid = doc.id;
          resolve(respondent_data);
        };
      }).catch(err => {
        console.log('this error called');
        resolve();
      });
    } catch (err) {
      console.log('Err getting respondent', err);
      resolve();
    };
  });
};


export { db_helper };
